import { useState } from 'react';
import { device } from '../utils/device';

export function useDevice() {
  const [value] = useState(device);
  return value;
}

export default useDevice;